import { Info } from 'components/common/Info'
import routes from 'constants/routes'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'
import { PropsWithChildren } from 'react'
const IntercomTrigger = dynamic(
  () => import('components/common/Intercom').then(m => m.IntercomTrigger),
  { ssr: false }
)

function Title({ children }: PropsWithChildren) {
  return (
    <h6 className='font-body text-sm font-bold tracking-normal'>{children}</h6>
  )
}

export function AdditionalInfo() {
  const { t } = useTranslation('common')

  return (
    <div className='space-y-3'>
      <Info theme='primary-light' iconName='filled-alert-question'>
        <Title>
          {t('how_it_works_drawer.additional_info.have_question.title')}
        </Title>
        <IntercomTrigger hideSpinner>
          <p className='text-sm text-purple-500 underline'>
            {t('how_it_works_drawer.additional_info.have_question.description')}
          </p>
        </IntercomTrigger>
      </Info>

      <Info theme='gray' iconName='filled-shield'>
        <Title>
          {t('how_it_works_drawer.additional_info.guarantee.title')}
        </Title>
        <p className='text-sm'>
          <Trans
            i18nKey='common:how_it_works_drawer.additional_info.guarantee.description'
            components={{
              link: (
                <a
                  target='_blank'
                  href={routes.howItWorks.guarantee}
                  className='text-secondary-default'
                />
              ),
            }}
          />
        </p>
      </Info>

      <Info theme='gray' iconName='filled-new'>
        <Title>
          {t('how_it_works_drawer.additional_info.new_condition.title')}
        </Title>
        <p className='text-sm'>
          {t('how_it_works_drawer.additional_info.new_condition.description')}
        </p>
      </Info>
    </div>
  )
}
